import { Connection } from "rete/types/connection";
import { NodeEditor } from "rete/types/editor";

import FlowCommand from "./FlowCommand";

function findConnection(oldConnection: Connection) {
  const { input, output } = oldConnection;

  return output.connections.find(c => c.input === input);
}

class ConnectionCommand extends FlowCommand {
  editor: NodeEditor;
  connection: Connection

  constructor(editor: NodeEditor, connection: Connection) {
    super();

    this.editor = editor;
    this.connection = connection;
  }
}

class ConnectionHelper extends ConnectionCommand {
  remove(conn: Connection) {
    const connection = findConnection(conn)

    if (connection) {
      this.editor.removeConnection(connection)
    }
  }

  add(conn: Connection) {
    this.editor.connect(conn.output, conn.input);
  }
}

export class AddConnectionCommand extends ConnectionHelper {
  undo() {
    this.remove(this.connection)
  }

  redo() {
    this.add(this.connection)
  }
}

export class RemoveConnectionCommand extends ConnectionHelper {
  undo() {
    this.add(this.connection)
  }

  redo() {
    this.remove(this.connection)
  }
}
